import React from 'react';

const PrintAction = () => {
  const handlePrint = (event: React.MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault();
    window.print();
  };

  return (
    <div className="job-actions">
      <h2>Actions</h2>
      <a className="print-link" href="#hints" onClick={handlePrint}>
        Print
      </a>
    </div>
  );
};

export default PrintAction;
